import { useAppContext } from '@contexts/app';
import { useEffect } from 'react';
import { useAccess } from '@hooks/access';

export const useFeedback = () => {
  const {
    admin: { isLogged: isAdmin },
  } = useAppContext();
  const access = useAccess();

  const button = document.querySelector('#atlwdg-trigger') as HTMLElement;

  useEffect(() => {
    if (!button) return;
    // eslint-disable-next-line immutable/no-mutation
    if (access.fieldUser || isAdmin) button.style.display = 'none';
  }, [button, access.fieldUser, isAdmin]);
};
